import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box, Button,
    Fade,
    Grid,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Modal,
    Popover,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import hashFill from '@iconify/icons-eva/hash-fill';
import { Icon } from '@iconify/react';
import DateRangeIcon from '@mui/icons-material/DateRange';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import FormatControl from '../components/_reportFilterForm/FormatControl';
import RenderFilterForm from '../components/_reportFilterForm/ReportFilterForm';
import { getMeasuresLists } from '../config/services/measures';
import { FILTER_TYPE, NUMBER_FILTER_TYPE } from '../constants/filterType';
import Granularity from './Granularity';

import { makeStyles } from '@mui/styles';
import { useRef } from "react";
import toast from 'react-hot-toast';
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/icon-cross-lg.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/icon-delete.svg";
import { ReactComponent as InputSearchIcon } from "../assets/icons/icon-feather-search.svg";
import { ReactComponent as HashtagIcon } from "../assets/icons/icon-hashtag.svg";
import { ReactComponent as EditIcon } from "../assets/icons/icon_edit.svg";
import { CustomTooltip } from '../utils/Reusables';
import getDataFromCube from '../utils/getCubeData';
import Loader from './Loader';
import QuickFilters from './QuickFilters';

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
    },
}));

const useStyles = makeStyles((theme) => ({

    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    formInput: {
        paddingLeft: 0,
        '&::placeholder': {
            paddingLeft: '-10px',
        }
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            backgroundColor: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    },
    listItemDescription: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    },
    searchFieldListMoreIcon: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    }
}));

export default function ReportFilter({ reportDetails, updateReportDetails }) {
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [openPopup, setOpenPopup] = useState(false);
    const [datasetSelectedId, setDatasetSelectedId] = useState(reportDetails?.reportDetails?.dataSetId?._id);
    const [anchorAddFilter, setAnchorAddFilter] = useState(null);
    const [anchorAddFilterStatus, setAnchorAddFilterStatus] = useState(false);
    const [searchMeasure, setSearchMeasure] = useState(null);
    const [measureList, setMeasureList] = useState([])
    const [reportFilters, setReportFilters] = useState(reportDetails?.reportDetails?.reportFilters);
    const [filterFormOpen, setFilterFormFilter] = useState(-1);
    const [filterFormState, setFilterFormState] = useState([]);
    const [deleteIndex, setDeleteIndex] = useState(-1)
    const [deletePopup, setDeletePopup] = useState(false)
    const [deleteAllPopup, setDeleteAllPopup] = useState(false)
    const [filterButtonWidth, setFilterButtonWidth] = useState('200px')
    const buttonRef = useRef();
    const classes = useStyles()

    const fetchMeasureList = () => {
        console.log(datasetSelectedId)
        let joinedDatasets = []
        if(reportDetails.reportDetails?.joinFlag && reportDetails.reportDetails?.dataSetId?.customJoin && reportDetails.reportDetails?.dataSetId?.customJoin.constructor === Array){
            joinedDatasets = reportDetails.reportDetails?.dataSetId?.customJoin.map(obj => obj.dataSetId)
        }
        let params = { dataSetId: [datasetSelectedId,...joinedDatasets], search: searchMeasure, sortKey: 'name', sortOrder: 1 , filter: { joinHiddenField: false }  }
        getMeasuresLists(params).then((res) => {
            setMeasureList(res?.result);
        });
    }

    const setIntialFilterFormState = () => {
        if (reportFilters?.length > 0) {
            reportFilters.map((obj, i) => {
                filterFormState[i] = { ...obj }
                if (!filterFormState[i].type || !filterFormState[i].dataSetType) {
                    for (let i = 0; i < measureList?.length; i++) {
                        if (measureList[i].name === obj.member.split(".")[1]) {
                            filterFormState[i].type = measureList[i].type;
                            filterFormState[i].dataSetType = measureList[i].dataSetType;
                        }
                    }
                }
                let filterFormStateNew = [...filterFormState];
                setFilterFormState(filterFormStateNew)
            })
        }
    }

    useEffect(() => {
        setIntialFilterFormState();
    }, [reportFilters]);

    const addFilter = (event) => {
        const buttonWidth = buttonRef.current.clientWidth;
        setFilterButtonWidth(buttonWidth);
        setSearchMeasure('');
        setAnchorAddFilter(event.currentTarget);
        setAnchorAddFilterStatus(true);
    }

    const handleClose = () => {
        setAnchorAddFilter(null);
        setAnchorAddFilterStatus(false);
    };

    const handleSearchMeasure = (e) => {
        let { value } = e.target
        setSearchMeasure(value)
    }

    const deleteReportFilterPopUp = (index) => {
        setDeleteIndex(index)
        setDeletePopup(true)
    }

    const toggleHideReportFilter = (index) => {
        let filterFormStateNew = [...filterFormState]
        let val = !filterFormStateNew[index].hidden;
        filterFormStateNew[index].hidden = val;
        setFilterFormState(filterFormStateNew);
        reportDetails.reportDetails.reportFilters[index].hidden = val;
        updateReportDetails({ reportDetails: reportDetails?.reportDetails })
    }

    const deleteReportFilter = () => {
        let index = deleteIndex;
        let filterFormStateNew = [...filterFormState]
        if (filterFormStateNew[index]?.operator === 'top' || filterFormStateNew[index]?.operator === 'bottom') {
            reportDetails.reportDetails.settings.topBottomFilter = false
            updateReportDetails({ reportDetails: reportDetails?.reportDetails })
        }
        filterFormStateNew.splice(index, 1)

        setFilterFormState(filterFormStateNew);

        if (filterFormStateNew?.length === 0)
            deleteAllFilter();

        setDeleteIndex(-1)
        setDeletePopup(false)
    }

    const deleteAllFilterPopUp = () => {
        setDeleteAllPopup(true)
    }

    const handleCancelDeleteAll = () => {
        setDeleteAllPopup(false)
    }

    const deleteAllFilter = () => {
        reportDetails.reportDetails.reportFilters = [];
        reportDetails.reportDetails.settings.topBottomFilter = false
        updateReportDetails({ reportDetails: reportDetails.reportDetails });
        let filterFormStateNew = [];
        setFilterFormState(filterFormStateNew);
        setDeleteAllPopup(false)
    }

    const handleCancelDelete = () => {
        setDeletePopup(false);
        setDeleteIndex(-1);
    }

    const openEditReportFilter = (filter, i) => {
        setFilterFormFilter(filterFormOpen === i ? -1 : i);
    }
    const applyFilter = async () => {
        let isValid = true
        if (reportDetails?.reportDetails) {
            for (let filter of filterFormState) {
                if (filter?.operator === "inDateRange" || filter?.operator === "notInDateRange") {
                    if (filter?.values.length === 2 && filter?.values.includes('')) {
                        toast.error('Date Range is required');
                        return false
                    }
                    else if (filter?.values.length === 2 && !filter?.values.includes('')) {
                        const { values } = filter
                        const [startDate, endDate] = values
                        if (new Date(startDate) > new Date(endDate)) {
                            toast.error('Start Date should be less than End Date');
                            return false
                        }
                        else if (new Date(endDate) < new Date(startDate)) {
                            toast.error('End Date should be greater than Start Date');
                            return false
                        }
                    }
                }
                if (filter?.operator === "top" || filter?.operator === "bottom") {
                    let order = filter?.operator === 'top' ? 'desc' : 'asc'
                    let orderBy = reportDetails?.reportDetails?.orderBy
                    let elementIndex = orderBy?.findIndex(ele => ele?.content?.key === filter?.member);
                    if (elementIndex === 0) {
                        orderBy[elementIndex].content.order = order
                    } else if (elementIndex === -1) {
                        orderBy.splice(0, 0, {
                            content: {
                                key: filter?.member,
                                order: order
                            }
                        })
                    } else {
                        let element = orderBy[elementIndex];
                        element.content.order = order;
                        orderBy.splice(elementIndex, 1);
                        orderBy.splice(0, 0, element);
                    }
                    reportDetails.reportDetails.limit = Number(filter?.limit)
                    reportDetails.reportDetails.settings.topBottomFilter = true
                    reportDetails.reportDetails.orderBy = orderBy
                }
                if (filter?.operator === 'beforeDate' || filter?.operator === 'afterDate') {
                    if (filter?.values[0] === '') {
                        toast.error('Date is required');
                        return false
                    }

                }
                if (filter?.values)
                    filter.values = filter?.values?.filter(e => e !== undefined && e !== null)
            }
            updateReportDetails({ reportDetails: reportDetails?.reportDetails });

            if (isValid) {
                let filtersApplied = [...filterFormState]
                reportDetails.reportDetails.reportFilters = _.orderBy(filtersApplied, ['filterOrder'], ['asc']);
                updateReportDetails({ reportDetails: reportDetails?.reportDetails });
            }
        }
    }

    const getFilterCubeData = (filter) => {
        return getDataFromCube(undefined, undefined, undefined, "limitReportFiter", { filter, reportDetails });
    }
    const clickMeasureListHandler = (measure) => {
        let obj = {
            type: measure?.type,
            member: measure.dataset.dataSetName + "." + measure?.name,
            displayName: measure?.displayName,
            operator: measure?.type === "time" ? 'inDateRange' : 'equals',
            values: [],
            relevantValues: [],
            dataSetType: measure?.dataSetType

        }
        filterFormState.unshift(obj)
        let filterFormStateNew = [...filterFormState];
        setFilterFormState(filterFormStateNew);
        setAnchorAddFilter(null);
        setAnchorAddFilterStatus(false);
    }

    const filterFormStateChange = (type, index, value, useDbData = false) => {
        let filterFormStateNew = [...filterFormState];
        if (type === "filterOperation") {
            filterFormStateNew[index].operator = value;
            if (useDbData) {
                filterFormStateNew[index].values = []
            }
            filterFormStateNew[index].useDbData = useDbData;
        }
        else if (type === 'operatorLimit') {
            filterFormStateNew[index].limit = value;
        }
        else {
            filterFormStateNew[index].values = value;
        }

        setFilterFormState(filterFormStateNew);
    }

    const openInPopup = (obj, i) => {
        if (obj?.valuesList?.length) {
            obj.valuesList = obj?.valuesList?.join("\n");
        }
        setRecordForEdit({ ...obj, index: i })
        setOpenPopup(true)
    }

    const addOrEdit = (form, resetForm) => {
        resetForm()
        setOpenPopup(false);
        if (form?.specificValue) {
            if (form?.valuesList)
                form.valuesList = form?.valuesList?.split('\n');
            else
                form.valuesList = [];
        }
        else
            form.valuesList = null;

        if (form?.index >= 0) {
            filterFormState[form?.index] = {
                member: form?.member,
                values: form?.values,
                operator: form?.operator,
                type: form?.type,
                displayName: form?.displayName,
                listType: form?.listType,
                specificValue: form?.specificValue,
                valuesList: form?.valuesList,
                selectAll: form?.selectAll,
                dataSetType: form?.dataSetType,
                limit: form?.limit,
                filterOrder: filterFormState?.filter(obj => obj?.listType !== undefined)?.length,
                index: form?.index,
                dateFilterProps: form?.dateFilterProps || undefined
            }
            let filterFormStateNew = [...filterFormState]
            setFilterFormState(filterFormStateNew);
            applyFilter();
        }
    }

    const handleCloseAddToSheet = () => {
        setRecordForEdit({})
        setOpenPopup(false)
    }

    useEffect(() => { fetchMeasureList() }, [datasetSelectedId, searchMeasure]);
    return (
        <RootStyle>
            <Box className="report-filters-section">
                <Box width="100%" height="100%" >
                    <Grid container alignItems="center">
                        <Grid item xs sx={{ pb: 1 }} >
                            <Typography variant="h5" className="filter-heading">Add Filter</Typography>
                        </Grid>
                        {/* <Grid item>
                            <IconButton gutterBottom color="primary" onClick={addFilter} > <AddIcon /> </IconButton>
                        </Grid> */}
                        <Button className="width-100 report_form_ui_btn primary" variant="contained" color="primary" startIcon={<AddIcon />} onClick={addFilter}
                            ref={buttonRef} >
                            Add Filter Condition
                        </Button>
                    </Grid>

                    <Popover id="measure-list" open={anchorAddFilterStatus} anchorEl={anchorAddFilter} onClose={handleClose}
                        PaperProps={{
                            style: {
                                width: filterButtonWidth, height: 'fit-content', borderTopLeftRadius: 0,
                                borderTopRightRadius: 0, marginTop: '10px', backgroundColor: 'transparent'
                            },
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <div>
                            <Box width="100%" height="100%" >
                                <TextField className="cm_rprt_setting_content report_form_ui_input" type="search" size="small"
                                    placeholder="Search field" onChange={handleSearchMeasure}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <InputSearchIcon className="input_search_icon" />
                                            </InputAdornment>
                                        ),
                                        classes: {
                                            input: classes.formInput,
                                            adornedEnd: classes.bgWhite + " form_input"
                                        }
                                    }}
                                />
                            </Box>
                            <Box className="field_list report_filter_list height-fit max-width-100 mt-0" sx={{ maxHeight: '300px', backgroundColor: '#fff' }} >
                                <List component="nav" aria-label="main mailbox folders" className="field_list ">
                                    {
                                        (measureList?.length)
                                            ? measureList?.map((measure, i) => (
                                                <ListItem className={classes.searchFieldListItem} key={i} button onClick={() => clickMeasureListHandler(measure)}
                                                    alignItems="flex-start">
                                                    <ListItemIcon sx={{ mt: '0px', mr: '4px' }} className={classes.searchFieldListIcon}>
                                                        {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon icon_color_main" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon icon_color_main" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl icon_color_main" /> : <LabelOutlinedIcon className="cm_measr_lbl icon_color_main" />}
                                                    </ListItemIcon>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <Typography className="text-plain"> 
                                                                {measure?.dataset ? (measure.dataset._id != datasetSelectedId ? ( `${(measure?.displayName ?? measure?.name)} (${measure.dataset.dataSetName})`): ( measure?.displayName ?? measure?.name)) : ( measure?.displayName ?? measure?.name)}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub"}>{measure?.description} </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </ListItem>
                                            ))
                                            : <ListItem button >
                                                No filters found!
                                            </ListItem>
                                    }
                                </List>
                            </Box>
                        </div>
                    </Popover>
                    <Box>
                        <List component="nav" aria-label="main mailbox folders" className="field_list">
                            {filterFormState?.map((obj, i) => (
                                <Box key={i}>
                                    {obj?.loader && <Loader />}
                                    <ListItem key={i} sx={{ p: 0 }}>
                                        <Box display="block" width="100%" className="filter-box-item">
                                            <Box>
                                                <Stack direction="row" className="width-100" spacing={1} flexShrink={0} sx={{ my: 0 }}>
                                                    <Accordion className="width-100">
                                                        <AccordionSummary
                                                            className="filter-box-item-summary"
                                                            expandIcon={<DropDownIcon />}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                        >
                                                            <ListItemIcon sx={{ paddingTop: '5px', marginRight: '12px' }}>
                                                                <HashtagIcon color="primary" />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                sx={{ marginLeft: '0px' }}
                                                                className="box-col-pointer text-plain"
                                                                primary={obj?.displayName || obj?.member?.split('.')[1]}
                                                                secondary={(obj?.operator === "equals" && obj?.useDbData) ? FILTER_TYPE[obj?.operator + "#true"] : (obj?.type === 'number' || obj?.type === 'count' ? NUMBER_FILTER_TYPE[obj?.operator] : FILTER_TYPE[obj?.operator])}
                                                                onClick={() => openEditReportFilter(obj, i)}
                                                            />
                                                        </AccordionSummary>
                                                        <AccordionDetails className="filter-box-item-details">
                                                            <Box style={{ display: filterFormOpen === i ? "block" : "block" }}>
                                                                <form id={"filter" + i}>
                                                                    {obj && <RenderFilterForm reportFilter={obj} i={i} filterFormStateChange={filterFormStateChange} />}
                                                                </form>
                                                            </Box>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Stack>
                                                <Stack>
                                                    <Box sx={{ pl: 0 }}>
                                                        {/* {
                                                            filterFormOpen === i ?
                                                                <IconButton color="primary" component="span">
                                                                    <KeyboardArrowUpIcon onClick={() => openEditReportFilter(obj, i)} />
                                                                </IconButton>
                                                                :
                                                                <IconButton color="primary" component="span">
                                                                    <KeyboardArrowDownIcon onClick={() => openEditReportFilter(obj, i)} />
                                                                </IconButton>
                                                        } */}

                                                        {/* <IconButton color="primary" component="span">
                                                                <DeleteIcon onClick={() => deleteReportFilterPopUp(i)} />
                                                            </IconButton>
                                                        {
                                                            obj?.operator === "equals" || obj?.type === "time" ?
                                                                <Tooltip title="Add to report">
                                                                    <IconButton color="primary" component="span">
                                                                        <EditIcon onClick={() => openInPopup(obj, i)} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                : null
                                                        } */}
                                                        {/* {
                                                            obj?.operator === "equals" || obj?.type === "time" ? */}
                                                        {obj.operator!="set" && obj.operator!="notSet" && <CustomTooltip title="Edit filter">
                                                            <IconButton color="primary" aria-label="Edit filter" component="span" className="hover-white form-icon-btn"
                                                                sx={{ p: 0, marginRight: 4 }}
                                                                onClick={() => openInPopup(obj, i)}>
                                                                <EditIcon className="filter-action-icon" />
                                                                <Typography variant="subtitle2" className="text-small" sx={{ pl: 1 }}> Add To Report</Typography>
                                                            </IconButton>
                                                        </CustomTooltip>}
                                                        <CustomTooltip title="Delete filter">
                                                            <IconButton color="primary" aria-label="Delete filter" component="span" className="hover-white form-icon-btn"
                                                                sx={{ p: 0, marginRight: 4 }}
                                                                onClick={() => deleteReportFilterPopUp(i)} >
                                                                <DeleteIcon className="filter-action-icon" />
                                                                <Typography variant="subtitle2" className="text-small" sx={{ pl: 1 }}>Delete</Typography>
                                                            </IconButton>
                                                        </CustomTooltip>
                                                        <CustomTooltip title="Hide filter">
                                                            <IconButton color="primary" aria-label="Delete filter" component="span" className="hover-white form-icon-btn"
                                                                sx={{ p: 0, marginRight: 4 }}
                                                                onClick={() => toggleHideReportFilter(i)} >
                                                                {/* <DeleteIcon className="filter-action-icon" /> */}
                                                                <Typography variant="subtitle2" className="text-small" sx={{ pl: 1 }}>{obj?.hidden ? 'UnHide' : 'Hide'}</Typography>
                                                            </IconButton>
                                                        </CustomTooltip>
                                                    </Box>

                                                </Stack>
                                            </Box>

                                        </Box>
                                    </ListItem>
                                </Box>
                            ))}
                        </List>
                    </Box>

                    {filterFormState?.length ? <Box width="100%" height="10%">
                        <Stack direction="row" width="100%" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                            <Button width="100%" className="report_form_ui_btn primary text-btn-small mr-2" variant="contained" color="primary" onClick={applyFilter} >
                                Apply Filter
                            </Button>
                            <Button width="100%" className="report_form_ui_btn primary text-btn-small" variant="contained" color="primary" onClick={deleteAllFilterPopUp}>
                                Delete all
                            </Button>
                        </Stack>
                    </Box> : null}

                </Box>
                <Granularity reportDetails={reportDetails} updateReportDetails={updateReportDetails} />
                {
                    !reportDetails?.reportDetails?.comparisonChartType
                        ? (
                            <QuickFilters reportDetails={reportDetails} updateReportDetails={updateReportDetails} />
                        )
                        : null

                }
                {/* <Popup title={"FormControl"} openPopup={openPopup} setOpenPopup={setOpenPopup}>
                    <FormatControl addOrEdit={addOrEdit} recordForEdit={recordForEdit} />
                </Popup>

                <Popup title={`Are you sure to delete this Filter ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete} onClose={false}>
                    <DialogActions>
                        <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
                        <Button onClick={deleteReportFilter} color="error" autoFocus>Delete</Button>
                    </DialogActions>
                </Popup>

                <Popup title={`Are you sure to delete all Filter ?`} openPopup={deleteAllPopup} setOpenPopup={handleCancelDeleteAll} onClose={false}>
                    <DialogActions>
                        <Button onClick={handleCancelDeleteAll} color="primary">Cancel</Button>
                        <Button onClick={deleteAllFilter} color="error" autoFocus>Delete</Button>
                    </DialogActions>
                </Popup> */}
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={openPopup}
                    onClose={() => setOpenPopup(false)}
                    closeAfterTransition
                >
                    <Fade in={openPopup}>
                        <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                            <CloseIcon onClick={handleCloseAddToSheet} className="enlarge-close" />
                            <Box className="modal-header modal-header2" >
                                <Typography variant="subtitle1" className="modal-header-title" >{`Add To Report`}</Typography>

                            </Box>
                            <Box className="modal-content modal-content2">
                                <FormatControl justifyContent="flex-start" addOrEdit={addOrEdit} recordForEdit={recordForEdit} handleCloseAddToSheet={handleCloseAddToSheet}
                                    mode="addToReport" labelType="placeholder" alignType="center" />
                            </Box>

                        </Box>
                    </Fade>
                </Modal>

                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={deletePopup}
                    onClose={() => setDeletePopup(false)}
                    closeAfterTransition
                >
                    <Fade in={deletePopup}>
                        <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                            <Box className="modal-content-simple">
                                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this Filter ?`}</Typography>
                                <Box className="modal-footer-simple">
                                    <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                    <Button onClick={deleteReportFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>

                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className="modal-root"
                    open={deleteAllPopup}
                    onClose={() => setDeleteAllPopup(false)}
                    closeAfterTransition
                >
                    <Fade in={deleteAllPopup}>
                        <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                            <Box className="modal-content-simple">
                                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this report all Filter ?`}</Typography>
                                <Box className="modal-footer-simple">
                                    <Button onClick={handleCancelDeleteAll} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                    <Button onClick={deleteAllFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>

            </Box>
        </RootStyle>
    );
}
